import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { mdlLanguage } from "../../../models/ui-models/Language";
import _ from "lodash";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faCircle, faUsd } from "@fortawesome/free-solid-svg-icons";
import { mdlFactSheetTemplate } from "../../../models/domain/FactSheetTemplate";
import { mdlFactSheetInfo } from "../../../models/domain/FactSheetInfo";
import { Skeleton } from "antd";
import { InputHelper } from "../../../utils/InputHelper";

export type ResortTemplateProps = {
    printMode?: boolean;
    data?: mdlFactSheetTemplate;
    selectedHotel?: string;
    selectedLanguage?: mdlLanguage;
}

export const ResortTemplate = function ResortTemplate(props: ResortTemplateProps) {
    const [templateData, setTemplateData] = useState<mdlFactSheetTemplate>();
    const [loader, setLoader] = useState<boolean>(false);
    const { t } = useTranslation();
    useEffect(() => {
        if (props.selectedHotel && !loader) {
            setTemplateData(props.data)
        }
    }, [props]);

    const renderCheckItem = (text: string, hasPrice = false, value : string) => (
        <div className="flex items-center report-line py-1.5 mb-1" style={{position: "relative"}}>
            {hasPrice &&
                <span className="fa-layers" style={{ position: 'absolute', left: '-20px', top: (props.printMode != null ? '13px' : '0'), color: '#fff' }}>
                    <FontAwesomeIcon icon={faCircle} fontSize={35} />
                    <FontAwesomeIcon icon={faUsd} color={"#03a9f4"} fontSize={10} />
                </span>
            }
            <span className="fa-layers" style={{ color: '#fff' , marginRight: "10px", top: (props.printMode != null ? '13px' : '0')}}>
                <FontAwesomeIcon icon={faCircle} fontSize={35} />
                <FontAwesomeIcon icon={faCheck} color={"#03a9f4"} fontSize={10} />
            </span>
            <span className="text-gray-600 text-sm">{text} { ( !InputHelper.isNullOrUndefinedOrEmpty(value) && value.toLowerCase() != "true" ? ` : ${value}` : "")}</span>
        </div>
    );

    return (
        !templateData ?
        <>
            <Skeleton />
        </>
        :
        <>
            {/* Hotel Info Header */}
            <div style={{backgroundColor: "#03a9f4", padding:"20px"}}>
            <div className="row g-0 mb-4 " style={{width:(props.printMode != null && props.printMode ? '1000px' : 'auto')}}>
                <div className="col-8 pt-3" >
                    <div className="py-3">
                        <div className="report-line mb-2">
                            <div className="d-flex">
                                {
                                    templateData && templateData.star &&
                                    Array.from({ length: templateData.star }, (_, index) => (
                                        <span style={{ color: '#ffd800', fontSize: "25px"  }}>★</span>
                                    ))
                                }
                            </div>
                        </div>
                        <h1 className="text-white h5">{templateData.hotelName}</h1>
                    </div>
                    <div className=" mb-4">
                        <label className="text-white py-2" >{templateData?.hotelLocation}</label>
                    </div>
                </div>
                <div className="col-4">
                    {
                        templateData?.images &&
                        <img
                            src={_.first(templateData?.images)?.value}
                            className="w-100 h-100 object-fit-cover"
                            style={{width:(props.printMode != null && props.printMode ? '250px' : 'auto')}}
                        />
                    }
                </div>
            </div>

            {
                templateData && templateData.list &&
                Array.from(templateData.list.reduce((map, item:mdlFactSheetInfo) => map.set(item.categoryId, item.categoryName), new Map()).values()).map(item =>
                    <div className="px-4" >
                        <div className="mb-4">
                            <h2 className="border-bottom border-2 pb-2 mb-2 h5">
                                <span style={{ color: '#fff', padding: "5px" }}>
                                {item}
                                </span>
                            </h2>
                            <div className="row" style={{width:(props.printMode != null && props.printMode ? '1000px' : 'auto')}}>
                                {
                                    templateData.list?.filter(x => x.categoryName == item).map((info: mdlFactSheetInfo , subIndex: number) => (
                                        info.questionName &&
                                        <div className="col-3">
                                            {renderCheckItem(info.questionName, info.isExtra, info.value || "")}
                                        </div>
                                    ))
                                }
                            </div>
                        </div>

                        
                    </div>
                )
            }
            </div>
        </>
    )
}